// extracted by mini-css-extract-plugin
export default {"successContainer":"InquireSuccess_successContainer__nvdS9","redirect":"InquireSuccess_redirect__j09zc"};